const STORE_LINKS = {
  android: `https://play.google.com/store/apps/details
  ?id=com.jobcase.member&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1`,
  ios: 'https://apps.apple.com/us/app/jobcase/id1506836734?itsct=apps_box&itscg=30200',
};

const OPERATING_SYSTEMS = {
  ANDROID: 'android',
  IOS: 'ios',
  OTHER: 'other',
};

export {
  STORE_LINKS,
  OPERATING_SYSTEMS,
};

export default {
  STORE_LINKS,
  OPERATING_SYSTEMS,
};
